import ReleaseUpdateBanner from "../components/ui/ReleaseUpdateBanner"
import { useReleaseUpdate } from "../hooks/useReleaseUpdate"

interface ReleaseUpdateNoticeProps {
  currentVersion: string
  versionUrl: string
  onReload?: () => void
}

export default function ReleaseUpdateNotice({ currentVersion, versionUrl, onReload }: ReleaseUpdateNoticeProps) {
  const available = useReleaseUpdate(currentVersion, versionUrl)
  return <ReleaseUpdateBanner available={available} onReload={onReload ?? (() => window.location.reload())} />
}
